<div>
  <dx-data-grid
    [dataSource]="artifacts"
    [hoverStateEnabled]="true">

    <dxo-selection mode="none"></dxo-selection>

    <dxi-column dataField="ArtifactId" cellTemplate="isNewTemplate" caption="Is new" width="60" dataType="boolean"></dxi-column>
    <dxi-column dataField="XmlType" caption="Xml type" dataType="string"></dxi-column>
    <dxi-column dataField="Filename" caption="Filename" dataType="string"></dxi-column>

    <div *dxTemplate="let cell of 'isNewTemplate'">
      @if (calculateIsNewColumnValue(cell.data)) {
        <img src="/images/new-artifact.png" width="20px" height="20px"/>
      }
    </div>

  </dx-data-grid>
</div>